export default "__VITE_ASSET__3b1c66c0__"